import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Add from "../images/Add";
import Edit from "../images/Edit";
import AddFloorModal from "../modals/AddFloorModal";
import { Button, Divider, Input, Select, message } from "antd";
import Remove from "../images/Remove";
import ConfirmModal from "../modals/ConfirmModal";
import ApiService from "../../utils/ApiService";
import useUserStore from "../../stores/store";
import CustomInputNumber from '../CustomInputNumber';
import DependencyModal from '../modals/DependencyModal';

const { Option } = Select;

function TableConfigRow({ table, index, onUpdate, onRemove }) {
  const { name, capacity, shape } = table;

  // Handler to update the parent state
  const handleChange = (field, value) => {
    console.log('__value___', value);
    let validatedValue = value;


    // --- THIS IS THE FIX ---
    if (field === 'name' && value.length > 2) {
      message.warning('Table no can not exceeds 2 character!');
      return;
    } if (field === 'capacity') {
      // If the new value is greater than 20, force it to be 20.
      if (value > 20) {
        validatedValue = 20;
      }
      if (value === null || value === undefined) {
        validatedValue = 1; // Or your desired minimum
      }

      // Note: We don't need to check min={1} here, because
      // typing "1" then "0" (for "10") would be blocked.
      // The min={1} prop will fix it on blur.
    }

    onUpdate(index, field, validatedValue);
  };

  return (
    <div className="grid grid-cols-[minmax(180px,1fr)_120px_160px_auto] gap-4 items-center mb-3">
      {/* Column 1: Table No */}
      <div className="min-w-[400px] h-[32px]">
        <CustomInputNumber
          name="name"
          value={name}
          setValue={(value) => handleChange('name', value)}
          min={1}
          max={99}
          placeholder={'e.g. Table 01'}
          isDecimalAllowed={false}
          inputClasses="h-full"
        />
      </div>

      {/* Column 2: No of Chair */}
      <div className="min-w-[118px] h-[32px]">
        <CustomInputNumber
          name="capacity"
          value={capacity}
          setValue={(value) => handleChange('capacity', value)}
          placeholder={'capacity'}
          isDecimalAllowed={false}
          min={1}
          max={20}
          inputClasses="h-full"
        />
      </div>

      {/* Column 3: Table Shape */}
      <div className='min-w-[136px] h-[32px]'>
        <Select
          value={shape}
          onChange={(value) => handleChange('shape', value)}
          className="w-full h-full cursor-pointer"
          showSearch={false}
        >
          <Option value="Rectangle">Rectangle</Option>
          <Option value="Square">Square</Option>
          <Option value="Circle">Circle</Option>
          <Option value="Oval">Oval</Option>
        </Select>
      </div>

      {/* Column 4: Remove Button */}
      <Remove attributes={{
        color: "#EE3169",
        size: "24",
        classes: "cursor-pointer pl-3",
      }} clickHandler={() => onRemove(index)} />
    </div>
  );
}

function DinningTableLists({ data, getInitialRecords }) {
  const navigate = useNavigate();
  const { restaurantId: paramResId, branchId } = useParams();
  const { user, branches, restaurantId, restaurantName, setNetworkCall, showNotification } = useUserStore();

  const { floorPlanName, floorPlanId } = data
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false)
  const [tables, setTables] = useState([]);
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(true);
  const [dependencyObj, setDependencyObj] = useState({
    dependentOrders: []
  });
  const [openDependencyModal, setOpenDependencyModal] = useState(false);

  const onClickEditButton = () => {
    setShowAddModal(false)
  }

  // Updates a specific field for a specific table
  const handleUpdateTable = (index, field, value) => {
    // Create a new array with the updated item
    const newTables = tables.map((table, i) => {
      if (i === index) {
        return { ...table, [field]: value };
      }
      return table;
    });
    setTables(newTables);
    setSaveBtnDisabled(false);
  };

  // Removes a table from the list
  const handleRemoveTable = (index) => {
    if (index > -1) {
      const newTables = tables.filter((item, i) => i !== index);
      setTables(newTables);
      setSaveBtnDisabled(false);
      setShowConfirmModal(false)
    }
  };

  // Adds a new blank table to the end of the list
  const handleAddNewTable = () => {
    const newTable = {
      id: '', // Temporary ID
      name: ``,
      capacity: 2,
      shape: 'Rectangle',
      x: 0,   // Initial X position in Canvas
      y: 0    // Initial Y position in Canvas
    };
    setTables([...tables, newTable]);
    setSaveBtnDisabled(false);
  };

  function checkDuplicateTableNames(tableList) {
    const nameCount = {};

    tableList.forEach(table => {
      const name = table.name;
      if (nameCount[name]) {
        nameCount[name] += 1;
      } else {
        nameCount[name] = 1;
      }
    });

    const duplicates = Object.keys(nameCount).filter(name => nameCount[name] > 1);

    if (duplicates.length > 0) {
      console.warn("Duplicate table names found:", duplicates);
      return duplicates;
    }

    return [];
  }

  const onClickSaveButton = async () => {
    const hasInvalidName = tables.some(table => !table.name || table.name.trim() === "");
    const duplicateNames = checkDuplicateTableNames(tables);
    if (duplicateNames.length > 0) {
      showNotification(`Duplicate table no: ${duplicateNames}. Please make table no. unique.`);
      return;
    }

    if (hasInvalidName) {
      // 2. If an invalid name is found, show a notification and stop the save
      // This uses the 'showNotification' function from your useUserStore()
      showNotification("Table number cannot be empty. Please fill in all table number before saving.");
      return;
    }

    const params = {
      restaurantId: data.restaurantId,
      floor: {
        id: data.floorPlanId,
        tables
      }
    }
    await addTableToFloorName(params);
  }

  function onClickCancelButton() {
    return navigate(`/restaurants/${paramResId}/branch/${branchId}/floor-plan`);
  }


  const onClickRemoveTableButton = (index) => {
    setSelectedIndex(index)
    setShowConfirmModal(true)
  }

  /*API calls*/
  async function addTableToFloorName(params) {
    const token = user.token.token;
    setNetworkCall(true);

    try {
      const res = await ApiService.ADD_TABLE_TO_FLOOR(params, token);
      if (!res || res.code !== 200) {
        showNotification(res?.message || "Failed to fetch restaurant branches");
        return;
      }

      const { payload } = res;
      const { record } = payload
      const { dependentOrders, success } = record;
      if (!success) {
        setNetworkCall(false);
        setOpenDependencyModal(true);
        setDependencyObj(prev => ({
          ...prev,
          dependentOrders: dependentOrders
        }));
        return;
      }

      showNotification("Floor updated successfully", false)
      setSaveBtnDisabled(true);
      data.onSave();
    } catch (err) {
      showNotification(err?.response?.data?.message || "Something went wrong");
    } finally {
      setNetworkCall(false);
    }
  }
  /*API calls*/


  function onHandleDependencyModalCancel() {
    setOpenDependencyModal(false);
    getInitialRecords();
  }

  /*Use effect functions*/
  useEffect(() => {
    const dataTables = data.tables.length === 0 ? [{
      id: '',
      name: ``,
      capacity: 2,
      shape: 'Rectangle',
      x: 0,
      y: 0
    }] : data.tables;
    setTables(dataTables);
  }, [data])
  /*Use effect functions*/

  return (
    <div className="flex flex-col p-[12px]">
      <div className="flex flex-row items-center">
        <div className="text-[20px] font-medium">{floorPlanName} - No of Table  {tables?.length || 0}</div>
      </div>
      <Divider className="my-2" />

      <div className='w-[70%]'>
        {/* header */}
        <div className="w-[calc(100%-5%)] grid grid-cols-[minmax(180px,1fr)_120px_160px_auto] mt-[12px]">
          <label className="font-semibold text-gray-700">Table No <span className='text-red-500'>*</span></label>
          <label className="font-semibold text-gray-700 -ml-[12px]">No of Chair <span className='text-red-500'>*</span></label>
          <label className="font-semibold text-gray-700">Table Shape <span className='text-red-500'>*</span></label>
          <label className="font-semibold text-gray-700 w-[40px] h-auto">
            <div className='w-[5%] mb-1 pl-4'>
              <Add
                attributes={{
                  color: "#2EC12B",
                  size: "24",
                  classes: "cursor-pointer",
                }}
                clickHandler={handleAddNewTable}
              />
            </div>
          </label>
          <div /> {/* Empty div for alignment */}
        </div>
        {/* Dynamic List */}
        <div className='w-full'>
          <div className="w-full flex flex-col">
            {tables && tables.map((table, index) => (
              <div className='w-full flex items-start'
                key={`table-item-${index}`}>
                <div className='w-[95%]'>
                  <TableConfigRow
                    index={index}
                    table={table}
                    onUpdate={handleUpdateTable}
                    onRemove={onClickRemoveTableButton}
                  />
                </div>
                {/*{
                  index === tables.length - 1 && (
                    <div className='w-[5%] pt-1 pl-5'>
                      <Add
                        attributes={{
                          color: "#2EC12B",
                          size: "24",
                          classes: "cursor-pointer",
                        }}
                        clickHandler={handleAddNewTable}
                      />
                    </div>
                  )
                }*/}
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-row items-center space-x-3 mt-[24px]">
          <button className="cursor-pointer bg-[#FA6060] w-[100px] h-[42px] text-[14px] leading-[16px] font-bold rounded-[8px] text-white" onClick={onClickCancelButton}>Cancel</button>
          <button className={`cursor-pointer ${saveBtnDisabled ? 'bg-[#F0F0F0] text-[#B4B5BD] border border-px border-[#D9D9D9]' : 'bg-[#2EC12B]'} w-[100px] h-[42px] text-[14px] leading-[16px] font-bold rounded-[8px] text-white`} disabled={saveBtnDisabled} onClick={onClickSaveButton}>Save</button>
        </div>
      </div>

      <AddFloorModal
        key={floorPlanId}
        openModal={showAddModal}
        records={{
          onFinish: onClickEditButton,
          onCancel: () => { setShowAddModal(false) },
          name: floorPlanName
        }}
      />

      <ConfirmModal
        isModalOpen={showConfirmModal}
        centered
        records={{
          title: `Warning!!!`,
          message: `Are you sure, want to remove the Table no. ${tables[selectedIndex]?.name || ''}?`,
          handleOk: () => handleRemoveTable(selectedIndex),
          handleCancel: () => setShowConfirmModal(false),
          confirmText: "Yes",
          cancelconfirmText: "No",
          customStyle: {
            top: 250
          },
        }}
      />

      {dependencyObj.dependentOrders.length > 0 && (
        <DependencyModal
          open={openDependencyModal}
          showOkButton={false}
          context="FLOOR_DEP"
          title="Please clean the following table(s) to update!"
          dependentOrders={dependencyObj.dependentOrders}
          handleCancel={onHandleDependencyModalCancel}
        />
      )}
    </div>
  );
}

export default DinningTableLists;
